import { render, staticRenderFns } from "./LateralElement.vue?vue&type=template&id=0688e0da&scoped=true&"
import script from "./LateralElement.vue?vue&type=script&lang=js&"
export * from "./LateralElement.vue?vue&type=script&lang=js&"
import style0 from "./LateralElement.vue?vue&type=style&index=0&id=0688e0da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688e0da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileAction } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VListTile,
  VListTileAction,
  VListTileContent,
  VListTileTitle,
  VTooltip,
})
